import React, { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { styles } from 'yankees-react-utils';
import ObjectiveActionPlan from './ObjectiveActionPlan';
import ObjectiveDrills from './ObjectiveDrills';
import ObjectiveMetric from './ObjectiveMetric';

const ObjectiveTitle = styled.div`
    font-size: .825rem;
    color: white;
    font-weight: bold;
    background-color: ${styles.theme.background.blueZodiac};
    padding: 0.5rem;
`;
const ObjectiveSection = styled.div`
    display: flex;
    align-items: start;
    border: 1px solid ${styles.theme.fontColors.silver};
    border-top: 0;
    padding: 0.5rem;

    & img {
        max-width: 100% !important;
        height: unset !important;
    }
    p {
        margin-bottom: 0 !important;
    }
`;
const ExpandButton = styled.button`
    border: 1px solid ${styles.theme.fontColors.silver};
    border-radius: 0.25rem !important;
    padding: 0 0.25rem;
    width: 1.125rem;
    flex-shrink: 0;
    margin-top: 1px !important;
`;
const ObjectiveHeader = styled.div`
    font-weight: bold;
    font-size: 1rem;
`;
const SummarySection = styled(ObjectiveSection)`
    td {
        padding: 3px 6px 3px 3px;
        border: 1px solid;
    }
`;
const ActionPlanAndDrillsSection = styled.div`
    border: 1px solid ${styles.theme.fontColors.silver};
    border-top: 0;
    padding: 0.5rem;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 1rem;
    p {
        margin-bottom: 0 !important;
    }
    td {
        padding: 3px 6px 3px 3px;
        border: 1px solid;
    }
`;

const Objective = ({ objective }) => {
    const { t: translate } = useTranslation();
    const [showMore, setShowMore] = useState(true);

    return (
        <div>
            <ObjectiveTitle>
                {objective.Title}
            </ObjectiveTitle>
            <SummarySection>
                <ExpandButton onClick={() => setShowMore(!showMore)}>{ showMore ? '-' : '+' }</ExpandButton>
                <div className="ms-2">
                    <ObjectiveHeader>{translate('sections.my-objectives.summary')}:</ObjectiveHeader>
                    <div className="mt-1" dangerouslySetInnerHTML={{ __html: objective.Summary }} />
                </div>
            </SummarySection>
            {
                showMore && (
                    <>
                        <ActionPlanAndDrillsSection>
                            <ObjectiveActionPlan actionPlanItems={objective.ActionPlanItems} />
                            <ObjectiveDrills drills={objective.Drills} />
                        </ActionPlanAndDrillsSection>
                        <ObjectiveSection>
                            <div className="w-100">
                                <ObjectiveHeader>{translate('sections.my-objectives.metrics')} ({objective.Metrics.length})</ObjectiveHeader>
                                {objective.Metrics.map((metric) => (
                                    <div className="p-3" key={metric.ObjectiveMetricID}>
                                        <ObjectiveMetric metric={metric} />
                                    </div>
                                ))}
                            </div>
                        </ObjectiveSection>
                    </>
                )
            }
        </div>
    );
};

export default Objective;
